import React, {useContext, useEffect} from "react";
import {Context} from "states/Store";
import EAFormStepper from "components/common/EAFormStepper";
import {ContextCreationConfigRight} from "./steps/Configuration";
import {AttributsRight} from "./steps/Attributs";
import {FormProvider, useForm} from "react-hook-form";
import i18next from "i18next";
import {saveContextModel} from "services/edge/ContexteService";
import {useAlert} from "../../../../components/common/hooks/useAlert";
import {Trans} from "react-i18next";
import StepperMainInfo from "../../../../components/context/stepper/StepperMainInfo";
import ContextInfos from "../../../../components/context/stepper/ContextInfos";

const ContexteCreationContainer = ({onClose, onValidateSuccess}) => {
  const [state, ] = useContext(Context);

  let stepSetter;
  const getStepSetter = (setter) => {
    stepSetter = setter;
  };
  const {onError, onSuccess} = useAlert();

  const formMethods = useForm({
    mode: "onChange",
    delayError: 500,
    defaultValues: {
      name: "",
      description: "",
      corpsEmail: "",
      code: "",
      contextAttributes: [],
      tiersAttributes: [],
      demandeAttributes: []
    },
  });

  const  {trigger, getValues, watch} = formMethods;

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  const handleSubmit = async () => {
    const formValues = getValues();
    const name = formValues.name;
    try {
      await saveContextModel(state.account.id,formValues);
      onValidateSuccess();
      onSuccess(<Trans i18nKey="demandes.contextModel.notifications.created"><b>{{name}}</b></Trans>)
    } catch(e) {
      onError("INTERNAL_ERROR");
    }
  }

  const Infos = ({ title, subtitle, text, currentStep }) => {
    const tiersAttCount = getValues('tiersAttributes').length;
    const contextAttCount = getValues('contextAttributes').length;
    const demandeAttCount = getValues('demandeAttributes').length;
    const name = watch('name');
    const code = watch('code')
    return (
        <>
          <StepperMainInfo
              title={title}
              subtitle={subtitle}
              text={text}
          />
          <ContextInfos
              category={i18next.t('context.addTiers.context')}
              title={name}
              subtitle={code}
              onEdit={() => stepSetter(0)}
              displayModifyButton={currentStep!==0}
          />
          {contextAttCount?<ContextInfos
              category={i18next.t('demandes.contextModel.addedAttributes')}
              title={i18next.t('demandes.contextModel.creationForm.attributs.attributsAuContext')}
              subtitle={contextAttCount+' '+i18next.t('demandes.contextModel.nAttributs')}
              onEdit={() => stepSetter(1)}
              displayModifyButton={currentStep!==1}
          />:<></>}
          {tiersAttCount?<ContextInfos
              category={false}
              title={i18next.t('demandes.contextModel.creationForm.attributs.attributsAuTiers')}
              subtitle={tiersAttCount+' '+i18next.t('demandes.contextModel.nAttributs')}
              onEdit={() => stepSetter(2)}
              displayModifyButton={currentStep!==2}
          />:<></>}
          {demandeAttCount?<ContextInfos
              category={false}
              title={i18next.t("demandes.contextModel.attributsDeclarant")}
              subtitle={demandeAttCount+' '+i18next.t('demandes.contextModel.nAttributs')}
              onEdit={() => stepSetter(3)}
              displayModifyButton={currentStep!==3}
          />:<></>}
        </>
    )
  };

  const stepsContent = [
    {
      id: 'conf',
      name: i18next.t("demandes.contextModel.parametrage"),
      left: <Infos
          title={i18next.t('demandes.contextModel.creationForm.config.stepper.title')}
          subtitle={i18next.t('demandes.contextModel.creationForm.config.stepper.subTitle')}
          text={i18next.t('demandes.contextModel.creationForm.config.stepper.text')}
          displayModifyButton={false}
          currentStep={0}
      />,
      right: <ContextCreationConfigRight/>
    },
    {
      id:'attributsContext',
      name: i18next.t("demandes.contextModel.attributsContext"),
      left: <Infos
          title={i18next.t('demandes.contextModel.creationForm.attributs.stepper.title')}
/*          subtitle={i18next.t('demandes.contextModel.creationForm.attributs.stepper.subTitle')}
          text={i18next.t('demandes.contextModel.creationForm.attributs.stepper.text')}*/
          currentStep={1}
      />,
      right: <AttributsRight
        attributContextType={"contextAttributes"}
        title={i18next.t("demandes.contextModel.creationForm.attributs.titleContext")}
        hint={i18next.t("demandes.contextModel.creationForm.attributs.hint")}
        listTitle={i18next.t("demandes.contextModel.creationForm.attributs.listTitle")}
        listTitleExample={''}
        dialogTitle={i18next.t("attributes.createTitle")}
      />
    },
    {
      id: 'tiersAttribute',
      name: i18next.t("demandes.contextModel.attributsTiers"),
      left:  <Infos
          title={i18next.t('demandes.contextModel.creationForm.attributs.stepper.title')}
    /*      subtitle={i18next.t('demandes.contextModel.creationForm.attributs.stepper.subTitle')}
          text={i18next.t('demandes.contextModel.creationForm.attributs.stepper.text')}*/
          currentStep={2}
      />,
      right: <AttributsRight
        attributContextType={"tiersAttributes"}
        title={i18next.t("demandes.contextModel.creationForm.attributs.titleTiers")}
        hint={i18next.t("demandes.contextModel.creationForm.attributs.hintAuTiers")}
        listTitle={i18next.t("demandes.contextModel.creationForm.attributs.listTitle")}
        listTitleExample={''}
        dialogTitle={i18next.t("attributes.createTitle")}
      />
    },
    {
      id: 'demandeAttributes',
      name: i18next.t("demandes.contextModel.attributsDeclarant"),
      left:  <Infos
          title={i18next.t('demandes.contextModel.creationForm.attributs.stepper.title')}
/*          subtitle={i18next.t('demandes.contextModel.creationForm.attributs.stepper.subTitle')}
          text={i18next.t('demandes.contextModel.creationForm.attributs.stepper.text')}*/
          currentStep={3}
      />,
      right: <AttributsRight
        attributContextType={"demandeAttributes"}
        title={i18next.t("demandes.contextModel.creationForm.attributs.titleDeclarant")}
        hint={i18next.t("demandes.contextModel.creationForm.attributs.hintDeclarant")}
        listTitle={i18next.t("demandes.contextModel.creationForm.attributs.listTitle")}
        listTitleExample={''}
        dialogTitle={i18next.t("attributes.createTitle")}
      />
    },
/*    {
      id:'emailTemplate',
      name: i18next.t("demandes.contextModel.renseignement"),
      left: <></>,
      right: <EmailTemplateRight/>
    }*/
  ];

  const stepFieldMap = {
    0: ['name', 'code'],
    1: ['contextAttributes'],
    2: ['tiersAttributes'],
    3: ['demandeAttributes'],
    4: [],
  };

  const checkValidStep = async (stepIndex) => {
    const fields = stepFieldMap[stepIndex] || [];
    return await trigger(fields);
  };


  return (<FormProvider {...formMethods}>
    <form>
      <EAFormStepper
        stepsContent={stepsContent}
        onClose={onClose}
        onNext={()=> {}}
        checkValidStep={checkValidStep}
        onSubmit={handleSubmit}
        finalStepText={i18next.t("demandes.contextModel.creerModele")}
        getStepSetter={getStepSetter}
      />
    </form>
  </FormProvider>)
};

export default ContexteCreationContainer;
